/*
  Cat bond gallery lightbox (sections/hp-cat-bond.liquid and
  sections/gallery-grid.liquid, which both carry the hp-cat-bond class).

  Each section has its own <dialog>, so several galleries on one page work
  independently. A tile opens its image, or for a video the player markup kept
  in the tile's <template> (nothing loads until then). Closing or moving on
  empties the stage, which also stops any playing video.
*/
(function () {
  // The section loads this file once per instance; set up only once.
  if (window.hpCatBondLightboxLoaded) return;
  window.hpCatBondLightboxLoaded = true;

  const SLIDE_HALF_DURATION = 250;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initLightbox(sectionNode) {
    if (sectionNode.dataset.lightboxInitialized === 'true') return;

    const dialogNode = sectionNode.querySelector('.hp-cat-bond-lightbox');
    const stageNode = dialogNode?.querySelector('.hp-cat-bond-lightbox__stage');
    const items = Array.from(sectionNode.querySelectorAll('.hp-cat-bond__open'));
    if (!dialogNode || !stageNode || items.length === 0) return;

    sectionNode.dataset.lightboxInitialized = 'true';

    const prevButtonNode = dialogNode.querySelector('.hp-cat-bond-lightbox__prev');
    const nextButtonNode = dialogNode.querySelector('.hp-cat-bond-lightbox__next');
    let activeIndex = 0;
    let isSliding = false;

    // Tiles can be hidden (the gallery grid's Load more), and the lightbox
    // steps over those, so this is checked each time it opens.
    const isShown = (itemNode) => itemNode.getClientRects().length > 0;

    const updateNavButtons = () => {
      const hasOthers = items.filter(isShown).length > 1;
      prevButtonNode.hidden = !hasOthers;
      nextButtonNode.hidden = !hasOthers;
    };

    // The next shown item from the active one, in the step's direction.
    const nextShownIndex = (step) => {
      for (let offset = 1; offset < items.length; offset++) {
        const index = (activeIndex + step * offset + items.length * offset) % items.length;
        if (isShown(items[index])) return index;
      }
      return activeIndex;
    };

    const setItem = (index) => {
      activeIndex = (index + items.length) % items.length;
      const tileNode = items[activeIndex].closest('.hp-cat-bond__tile');
      const playerNode = tileNode.querySelector('.hp-cat-bond__player');

      // The tile's label, shown under the image or video.
      const labelNode = tileNode.querySelector('.hp-cat-bond__label');
      const captionNode = labelNode ? document.createElement('div') : null;
      if (captionNode) {
        captionNode.className = 'hp-cat-bond-lightbox__caption';
        captionNode.innerHTML = labelNode.innerHTML;
      }

      let mediaNode;
      if (playerNode) {
        mediaNode = playerNode.content.cloneNode(true);
      } else {
        mediaNode = document.createElement('img');
        mediaNode.className = 'hp-cat-bond-lightbox__image';
        mediaNode.src = items[activeIndex].dataset.lightboxSrc;
        mediaNode.alt = tileNode.querySelector('.hp-cat-bond__media')?.alt || '';
      }
      stageNode.replaceChildren(...[mediaNode, captionNode].filter(Boolean));
    };

    const slide = (step) => {
      if (isSliding) return;
      const targetIndex = nextShownIndex(step);
      if (targetIndex === activeIndex) return;

      if (reducedMotion.matches) {
        setItem(targetIndex);
        return;
      }

      isSliding = true;
      const className = step < 0 ? 'is-sliding-right' : 'is-sliding-left';
      stageNode.classList.add(className);

      setTimeout(() => {
        // Skip the swap if the lightbox was closed mid-slide.
        if (dialogNode.open) setItem(targetIndex);
      }, SLIDE_HALF_DURATION);
      setTimeout(() => {
        stageNode.classList.remove(className);
        isSliding = false;
      }, SLIDE_HALF_DURATION * 2);
    };

    items.forEach((itemNode, index) => {
      itemNode.addEventListener('click', () => {
        setItem(index);
        updateNavButtons();
        dialogNode.showModal();
      });
    });

    prevButtonNode.addEventListener('click', () => slide(-1));
    nextButtonNode.addEventListener('click', () => slide(1));
    dialogNode.querySelector('.hp-cat-bond-lightbox__close').addEventListener('click', () => dialogNode.close());

    // The dialog and the stage fill the screen, so a click on either is a
    // click on the backdrop. Clicks on the image or video itself are ignored.
    dialogNode.addEventListener('click', (event) => {
      if (event.target === dialogNode || event.target === stageNode) dialogNode.close();
    });

    dialogNode.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') slide(-1);
      if (event.key === 'ArrowRight') slide(1);
    });

    // Covers Escape too, which closes a modal dialog natively.
    dialogNode.addEventListener('close', () => stageNode.replaceChildren());
  }

  function initAll(root) {
    root.querySelectorAll('.hp-cat-bond').forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  // The theme editor swaps in fresh markup when the section's settings change.
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
